import { useStyles } from './Statistics.styles';
import { pieArcLabelClasses, PieChart } from '@mui/x-charts/PieChart';
import { DefaultizedPieValueType } from '@mui/x-charts/models';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { StatisticsChartData } from './Statistics.types';

interface StatisticsChartProps {
  data: StatisticsChartData;
}

export const StatisticsChart: React.FC<StatisticsChartProps> = ({ data }) => {
  const classes = useStyles();

  const TOTAL = data.items.map((item) => item.value).reduce((a, b) => a + b, 0);

  const getArcLabel = (params: DefaultizedPieValueType) => {
    const percent = params.value / TOTAL;
    return `${(percent * 100).toFixed(0)}%`;
  };

  const getOuterRadius = () => {
   if (data.items.some(item => item.value > 10000)) {
    return 55 
   } else return 60
  }

  const labelsWithValues = data.items.map((item) => {
    return {
      ...item,
      label: `${item.label} (${item.value})`,
    };
  });

  const valueFormatter = () => '';

  return (
    <div className={classes.chip} style={{ minHeight: '250px' }}>
      <Stack
        direction={{ xs: 'row', md: 'column' }}
        alignItems={{ xs: 'left', md: 'left' }}
        justifyContent="center"
        sx={{ width: '100%' }}
      >
        <Typography
          style={{
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontSize: 15,
            paddingLeft: '15px',
            paddingTop:  data.items.length > 0 ? '15px' : '0px',
            fontWeight: 'bold',
          }}
        >
          {data.name}
        </Typography>
        {data.items.length ? (
          <PieChart
            series={[
              {
                outerRadius: getOuterRadius(),
                arcLabelRadius: data.items.length > 1 ? 30 : 0,
                data: labelsWithValues,
                arcLabel: getArcLabel,
                highlightScope: { fade: 'global', highlight: 'item' },
                faded: { color: 'gray' },
                valueFormatter
              },
            ]}
            sx={{
              [`& .${pieArcLabelClasses.root}`]: {
                fill: 'white',
                fontSize: 13,
              },
            }}
            slotProps={{
              legend: {
                labelStyle: {
                  fontSize: 13,
                },
                itemMarkWidth: 14,
                itemMarkHeight: 14,
              },
            }}
            height={220}
            margin={{ right: 180 }}
          />
        ) : (
          <div className={classes.noData}>
            <p>Brak danych</p>
          </div>
        )}
      </Stack>
    </div>
  );
};
